import React, { useEffect, useState } from "react";
import { message } from "antd";
import Layout from "../components/Layout/Layout";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import IMAGES from "../img/image";
import {
  ChevronLeftSvg,
  ListSvg,
} from "../components/AllSvgModulesExport/LoginSvg";
import "./css/Leaderboard.css";
import HeroSvg from "../components/Layout/HeroSvg";
import { useDispatch } from "react-redux";
import { setActiveButton } from "../redux/features/footerMenuSlice";
import { useNavigate } from "react-router-dom";
import { apiClient } from "../config/api.client";
import { USER_LEADERBOARD } from "../constants/api.constant";

const Leaderboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sideMenu, setSideMenu] = useState(false);
  const [currentMonthData, setCurrentMonthData] = useState(null);
  const [lastMonthData, setLastMonthData] = useState(null);
  const [countdown, setCountdown] = useState("");
  const [tab, setTab] = useState(0);
  const [list, setList] = useState(null);
  const [rewardList, setRewardList] = useState(null);
  const [reward, setReward] = useState(null);
  const [showReward, setShowReward] = useState(false);
  const [user, setUser] = useState(null);
  const [position, setPosition] = useState(null);
  //
  const [loading, setLoading] = useState(true);

  const getCurrentDateRange = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    const startDate = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-01`;
    const endDate = `${currentYear}-${String(currentMonth).padStart(
      2,
      "0"
    )}-${new Date(currentYear, currentMonth, 0).getDate()}`;

    return { startDate, endDate };
  };

  const getNextMonthStartDate = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const nextMonth = today.getMonth() + 1; // Next month
    const nextMonthStart = new Date(currentYear, nextMonth, 1);
    // Set the time to midnight (start of the month)
    nextMonthStart.setHours(0, 0, 0, 0);
    return nextMonthStart;
  };

  const calculateCountdown = () => {
    const nextMonthStart = getNextMonthStartDate();
    const now = new Date();
    const timeDiff = nextMonthStart - now;
    // Calculate the remaining days, hours, minutes, and seconds
    const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDiff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
    const seconds = Math.floor((timeDiff / 1000) % 60);

    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  };

  const getLeaderboard = async () => {
    try {
      setLoading(true);
      const res = await apiClient.get(USER_LEADERBOARD);
      if (res.data) {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        
        // Set current month data
        if (res.data.currentMonth && res.data.currentMonth.leaderboard) {
          setCurrentMonthData(res.data.currentMonth.leaderboard);
        }
        
        // Set last month data
        if (res.data.lastMonth && res.data.lastMonth.leaderboard) {
          setLastMonthData(res.data.lastMonth.leaderboard);
        }
      } else {
        setLoading(false);
        console.log('Failed to fetch leaderboard data');
      }
    } catch (error) {
      setLoading(false);
      console.log(error.message);
    }
  };

  const getLeaderboardRewardList = async () => {
    try {
      const res = await apiClient.get(
        `/leaderboard/leaderboardrewardsforusers`
      );
      if (res.data.success) {
        setList(res.data.data);
      } else {
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  async function getRewardList() {
    try {
      const res = await apiClient.get("/leaderboard/get-rewards", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });
      if (res.data.success) {
        setRewardList(res.data.data);
      } else {
        console.log(res.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  function handleCheckReward(index) {
    if (!rewardList) {
      return message.error("Reward is not set by Admin");
    }
    const position = rewardList.filter(
      (item) => item?.position == index + 1
    )[0];
    // If no position is found, set the last item in the list
    const rewardToSet = position ? position : rewardList[rewardList.length - 1];
    setReward(rewardToSet);
    setShowReward(!showReward);
  }

  useEffect(() => {
    getRewardList();
  }, []);

  useEffect(() => {
    getLeaderboard(); // Fetch leaderboard data for the current month
    const countdownInterval = setInterval(() => {
      setCountdown(calculateCountdown());
    }, 1000);

    return () => clearInterval(countdownInterval); // Clear the interval on component unmount
  }, []);

  useEffect(() => {
    getLeaderboardRewardList();
  }, []);

  const onClose = () => {
    dispatch(setActiveButton("home"));
    navigate("/");
    localStorage.setItem("activeButton", "home");
  };

  return (
    <Layout>
      {/* DESKTOP  */}
      {/* DESKTOP  */}
      {/* DESKTOP  */}
      <div className="d-none d-lg-block">
        {showReward && (
          <div
            className="showreward"
            onClick={() => setShowReward(!showReward)}
          >
            <div className="user-reward">
              <h5>{user?.fname}</h5>
              <h6>Total Spent: ₹{user?.totalSpent}</h6>
              <h6>Position: {position}</h6>
              <h6>Reward: ₹{reward?.reward}</h6>
              <p>
                <b>Note:</b> The reward will be given after the specified time
                ends, and the reward's position and price may change before the
                time runs out.
              </p>
            </div>
          </div>
        )}
        <div className="leaderboard-container">
          <h4 className="heading">The Challenge will reset in: {countdown}</h4>
          <div className="leaderboardbuttons">
            <button
              onClick={() => setTab(0)}
              className={`${tab === 0 && "active"}`}
            >
              Active Challenge
            </button>
            <button
              onClick={() => setTab(1)}
              className={`${tab === 1 && "active"}`}
            >
              Past Months
            </button>
          </div>
          {currentMonthData && currentMonthData?.length === 0 ? (
            <div className="norecord">
              <h5 className="m-0">NO RECORD</h5>
            </div>
          ) : tab === 0 ? (
            <div className="leaderboard-list">
              {currentMonthData?.map((item, index) => {
                return (
                  <div
                    className={`items ${index <= 2 && "winner"}`}
                    key={item._id}
                    onClick={() => {
                      handleCheckReward(index);
                      setUser({
                        fname: item.name,
                        totalSpent: item.totalPurchaseAmount
                      });
                      setPosition(index + 1);
                    }}
                  >
                    {index <= 2 && (
                      <img
                        className="ms-2 mb-2"
                        src={`${
                          index === 0
                            ? IMAGES.first
                            : index === 1
                            ? IMAGES.second
                            : IMAGES.third
                        }`}
                        alt=""
                      />
                    )}
                    <div>
                      <span className="me-1">
                        {index > 2 && <p>{index + 1 + ")"}</p>}
                      </span>
                      <p>{item?.name}</p>
                    </div>
                    <span className="d-flex align-items-center">
                      ₹{item?.totalPurchaseAmount}
                      <ExpandCircleDownIcon className="icon" />
                    </span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="leaderboard-rewards">
              {lastMonthData?.length > 0 ? (
                lastMonthData.map((item, index) => {
                  return (
                    <div className="winners-list" key={item._id}>
                      <div className="winners">
                        <div className="index-and-username">
                          <span className="index me-2">{index + 1}</span>
                          <span className="username">{item.name}</span>
                        </div>
                        <span className="text-dark d-flex align-items-center">
                          <small>₹{item?.totalPurchaseAmount}</small>
                        </span>
                      </div>
                    </div>
                  );
                })
              ) : (
                list?.winners?.map((item, index) => {
                  return (
                    <div className="winners-list" key={index}>
                      <div className="winners">
                        <div className="index-and-username">
                          <span className="index me-2">{index + 1}</span>
                          <span className="username">{item.fname}</span>
                        </div>
                        <span className="text-dark d-flex align-items-center">
                          <small>₹{item?.prize}</small>
                        </span>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}
        </div>
      </div>

      {/* MOBILE */}
      {/* MOBILE */}
      {/* MOBILE */}
      <div className={`account-modal-container d-lg-none d-md-none`}>
        <HeroSvg />
        <div className="account-modal-container-content">
          <div className="top-left-content">
            <div className="box-1 center" onClick={onClose}>
              <ChevronLeftSvg />
            </div>
            <h2 className="mb-0">Leaderboard</h2>
          </div>
          <div
            className="top-right-content box-2 center"
            onClick={() => setSideMenu(!sideMenu)}
          >
            <ListSvg />
          </div>
        </div>
        {showReward && (
          <div
            className="showreward"
            onClick={() => setShowReward(!showReward)}
          >
            <div className="user-reward">
              <h5>{user?.fname}</h5>
              <h6>Total Spent: ₹{user?.totalSpent}</h6>
              <h6>Position: {position}</h6>
              <h6>Reward: ₹{reward?.reward}</h6>
              <p>
                <b>Note:</b> The reward will be given after the specified time
                ends, and the reward's position and price may change before the
                time runs out.
              </p>
            </div>
          </div>
        )}
        <div className="leaderboard-container">
          <h4 className="heading">The Challenge will reset in: {countdown}</h4>
          <div className="leaderboardbuttons">
            <button
              onClick={() => setTab(0)}
              className={`${tab === 0 && "active"}`}
            >
              Active Month
            </button>
            <button
              onClick={() => setTab(1)}
              className={`${tab === 1 && "active"}`}
            >
              Past Month
            </button>
          </div>
          {currentMonthData && currentMonthData?.length === 0 ? (
            <div className="norecord">
              <h5 className="m-0">NO RECORD</h5>
            </div>
          ) : tab === 0 ? (
            <div className="leaderboard-list">
              {currentMonthData?.map((item, index) => {
                return (
                  <div
                    className={`items ${index <= 2 && "winner"}`}
                    key={item._id}
                    onClick={() => {
                      handleCheckReward(index);
                      setUser({
                        fname: item.name,
                        totalSpent: item.totalPurchaseAmount
                      });
                      setPosition(index + 1);
                    }}
                  >
                    {index <= 2 && (
                      <img
                        className="ms-2 mb-2"
                        src={`${
                          index === 0
                            ? IMAGES.first
                            : index === 1
                            ? IMAGES.second
                            : IMAGES.third
                        }`}
                        alt=""
                      />
                    )}
                    <div>
                      <span className="me-1">
                        {index > 2 && <p>{index + 1 + ")"}</p>}
                      </span>
                      <p>{item?.name}</p>
                    </div>
                    <span className="d-flex align-items-center">
                      ₹{item?.totalPurchaseAmount}
                      <ExpandCircleDownIcon className="icon" />
                    </span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="leaderboard-rewards">
              {lastMonthData?.length > 0 ? (
                lastMonthData.map((item, index) => {
                  return (
                    <div className="winners-list" key={item._id}>
                      <div className="winners">
                        <div className="index-and-username">
                          <span className="index me-2">{index + 1}</span>
                          <span className="username">{item.name}</span>
                        </div>
                        <span className="text-dark d-flex align-items-center">
                          <small>₹{item?.totalPurchaseAmount}</small>
                        </span>
                      </div>
                    </div>
                  );
                })
              ) : (
                list?.winners?.map((item, index) => {
                  return (
                    <div className="winners-list" key={index}>
                      <div className="winners">
                        <div className="index-and-username">
                          <span className="index me-2">{index + 1}</span>
                          <span className="username">{item.fname}</span>
                        </div>
                        <span className="text-dark d-flex align-items-center">
                          <small>₹{item?.prize}</small>
                        </span>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Leaderboard;
